export default __webpack_public_path__ + "static/media/Control_2_Thermocycler.07d62aea.svg";